<mat-button-toggle-group
  class="sub-tab-toggle"
  [value]="activeSubTab"
  (change)="onSubTabChanged($event.value)"
  aria-label="Output assets sub-tab"
>
  <mat-button-toggle value="range">
    <mat-icon>format_list_numbered</mat-icon>
    Range
  </mat-button-toggle>
  <mat-button-toggle value="ev">
    <mat-icon>tune</mat-icon>
    EV
  </mat-button-toggle>
</mat-button-toggle-group>

<div [hidden]="activeSubTab !== 'range'">
  <app-output-assets-range-view
    [product]="product"
    [colPerScreen]="colPerScreen"
    [editCallback]="editCallback"
    (bucketLoaded)="onBucketLoaded('range', $event)"
  ></app-output-assets-range-view>
</div>

@if (evActivated) {
  <div [hidden]="activeSubTab !== 'ev'">
    <app-output-assets-ev-view
      [product]="product"
      [colPerScreen]="colPerScreen"
      [editCallback]="editCallback"
      [activated]="true"
      (bucketLoaded)="onBucketLoaded('ev', $event)"
    ></app-output-assets-ev-view>
  </div>
}
